import {AfterViewInit, ChangeDetectionStrategy, Component, effect, inject} from '@angular/core';
import { RouterOutlet } from '@angular/router';
import Blazy from 'blazy';
import {headerInit} from '@itc';
import {Nav} from '@entities/navigation/nav';
import {UserStore} from '@library/entities/user/user.store';
import {LoaderService} from '@shared/lib/loader.service';
import {Logger} from '@shared/utils/logger';


@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.html',
  styleUrl: './app.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class App implements AfterViewInit {
  private user = inject(UserStore);
  private nav = inject(Nav);
  protected loader = inject(LoaderService);
  private canGoToLogin = false;

  constructor() {
    this.user.init();

    effect(() => {
      const isAuthenticated = this.user.isLogged();
      Logger.log('AUTH EFFECT isAuthenticated', isAuthenticated);

      if (!isAuthenticated && this.canGoToLogin) {
        this.nav.toLogin();
      }

      this.canGoToLogin = true;
    });
  }

  async ngAfterViewInit() {
    // const {headerInit} = await import('@itc');

    headerInit({
      blazy: Blazy
    });
  }
}
